import { Component, OnInit } from '@angular/core';
import {HeaderService} from "../../../../services/header/header.service";

@Component({
  selector: 'app-banque',
  templateUrl: './banque.component.html',
  styleUrls: ['./banque.component.scss']
})
export class BanqueComponent implements OnInit {

  constructor(private headerService: HeaderService) { }
    
    ngOnInit(): void {
      this.headerService.setConfig({
          title: 'Compte bancaire',
          buttons: []
      });
    }
}
